var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"fixed":true,"title":_vm.pageTitle,"left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('van-nav-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }